import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { InviterBox } from "../components/InviterBox.tsx";
import axiosInstance from "../axiosInstance.tsx";
import { FullInviter } from "../components/FullInviter.tsx";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 40px;
       @media (max-width: 768px) {
    padding: 0;
    gap: 24px;
    padding-bottom: 15%
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  
  gap: 20px;
`;

export const InvitersPage: React.FC = ({setOnBack, setAfterHeader, inviters}) => {

  const [selectedInviter, setSelectedInviter] = useState(null);
  const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (selectedInviter) {
            setOnBack(() => () => setSelectedInviter(null));
            const inviter = inviters.find(inv => inv.id === selectedInviter);
            setAfterHeader(` ${inviter.name}`);
        }
    }, [selectedInviter])

useEffect(() => {
  axiosInstance.get("/accountCategories").then(resp => {
    const now = new Date().toISOString();

    const withTime = resp.data.map(cat => ({
      ...cat,
      fetchTime: now
    }));

    setCategories(withTime);
  });
}, []);



  return (
    <PageWrapper>
        {selectedInviter && categories.length > 0 && <FullInviter categories={categories} inviter={ inviters.find(inv => inv.id === selectedInviter)}></FullInviter>}
        {selectedInviter == null &&
      <FlexWrapper>
            {inviters.map((inviter) => {
        // время, когда данные были получены

                        const fetchTs = new Date(inviter.fetchTime).getTime(); // ms
        const nowTs = Date.now(); // ms
        const diffSec = (nowTs - fetchTs) / 1000; // сколько прошло

        const secondsRemaining = inviter.seconds_wait
          ? Math.max(0, Math.ceil(inviter.seconds_wait - diffSec))
          : 0;
        return (
          <InviterBox
            key={inviter.id}
            title={inviter.name}
            onSelect={() => setSelectedInviter(inviter.id)}
            completed={inviter.invited}
            need={inviter.settings.max_invites_per_chat || 1000}
            status={inviter.state}
            secondsRemaining={secondsRemaining}
          />
        );
      })}

               
      </FlexWrapper>
}
    </PageWrapper>
  );
};